export default __webpack_public_path__ + "static/media/francheville32.f243bae3.jpg";